module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/primary-column-line/primary-column-line.component.scss
// module id = ./src/app/modules/common-module/components/primary-column-line/primary-column-line.component.scss
// module chunks = 9